import React, { useState, ChangeEvent } from 'react';

interface SliderImagesEditorProps {
    editableContent: { [key: string]: string };
    handleImageChange: (imageId: string, newImageUrl: string) => void;
    handleSaveChanges: () => void;
    handleCancelEdit: () => void;
}

const SliderImagesEditor: React.FC<SliderImagesEditorProps> = ({
    editableContent,
    handleImageChange,
    handleSaveChanges,
    handleCancelEdit,
  }) => {
    const [selectedImageId, setSelectedImageId] = useState<string | null>(null);
    const [newImage, setNewImage] = useState<File | null>(null);
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  
    const galleryIds = ['pexels-thumb1', 'pexels-thumb2', 'pexels-thumb3', 'pexels-thumb4']; // IDs para la galería
  
    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (file && selectedImageId) {
        setNewImage(file);
      }
    };
  
    const handleSaveImage = async () => {
      if (newImage && selectedImageId) {
        const formData = new FormData();
        formData.append('image', newImage);
  
        try {
          const response = await fetch(`http://localhost:3001/upload-image`, {
            method: 'POST',
            body: formData,
          });
  
          const data = await response.json();
          const newImageUrl = data.imageUrl;
  
          handleImageChange(selectedImageId, newImageUrl); // Pasamos el ID de la imagen y la URL
          handleSaveChanges();
        } catch (error) {
          console.error('Error subiendo la imagen:', error);
        }
      }
    };
  
    return (
      <div className="editor-accordion">
        <div className="accordion-item">
          <h3 onClick={() => setIsAccordionOpen(!isAccordionOpen)}>
            Editar Imágenes de la Galería
          </h3>
  
          {isAccordionOpen && (
            <div className="accordion-content">
              <ul>
                {galleryIds.map((galleryId) => (
                  <li key={galleryId}>
                    <button onClick={() => setSelectedImageId(galleryId)}>
                      Cambiar {galleryId}
                    </button>
                    {selectedImageId === galleryId && (
                      <div>
                        <input type="file" onChange={handleFileChange} accept="image/*" />
                        <button onClick={handleSaveImage}>Guardar Imagen</button>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
              <button onClick={handleCancelEdit}>Cancelar</button>
            </div>
          )}
        </div>
      </div>
    );
  };
  

export default SliderImagesEditor;
